import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";
import Badge from "@/components/base/Badge";
import NewsCard from "@/components/base/NewsCard";
import DetailActions from "./DetailActions";

interface NewsDetailProps {
  news: NewsItem;
  related: NewsItem[];
}

export default function NewsDetail({ news, related }: NewsDetailProps) {
  return (
    <div className="mx-auto max-w-[900px] px-4 py-8 md:px-6">
      <div className="flex items-center gap-2">
        <Badge tone="accent">{news.category}</Badge>
        <span className="text-sm text-foreground-500">动漫新闻</span>
      </div>
      <h1 className="mt-3 text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
        {news.title}
      </h1>
      <div className="mt-4 flex flex-wrap items-center gap-4 border-b border-background-200 pb-5 text-sm text-foreground-500">
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-user-line"></i>
          {news.author}
        </span>
        <time className="inline-flex items-center gap-1.5">
          <i className="ri-time-line"></i>
          {news.publishTime}
        </time>
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-eye-line"></i>
          {news.views} 次阅读
        </span>
      </div>

      <div className="mt-6 aspect-[16/9] w-full overflow-hidden rounded-lg border border-background-200 bg-background-200">
        <img
          src={news.cover}
          alt={`《${news.title}》新闻配图`}
          title={`${news.title} 动漫新闻详情`}
          className="h-full w-full object-cover object-top"
        />
      </div>
      <p className="mt-2 text-center text-xs text-foreground-400">图：{news.title}（示意配图）</p>

      <article className="mt-7">
        {news.content.map((paragraph, index) => (
          <p key={index} className="mb-4 text-sm leading-8 text-foreground-700">
            {paragraph}
          </p>
        ))}
        <p className="rounded-lg border border-secondary-200 bg-secondary-50 p-4 text-sm leading-relaxed text-secondary-900">
          <i className="ri-information-line mr-1"></i>
          本文为风车动漫网编辑整理的演示内容，人物、作品与事件均为虚构示例，仅用于展示资讯阅读体验。
        </p>
      </article>

      <div className="mt-7">
        <DetailActions id={news.id} title={news.title} />
      </div>

      <div className="mt-6 flex flex-wrap items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
        <span className="text-sm font-medium text-foreground-800">所属分类：</span>
        <Link
          to="/category/news"
          className="inline-flex cursor-pointer items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-sm text-primary-800 transition-colors hover:bg-primary-200"
        >
          <i className="ri-newspaper-line"></i>
          动漫新闻
        </Link>
      </div>

      {related.length > 0 && (
        <section className="mt-12">
          <h2 className="mb-5 text-lg font-bold text-foreground-950">相关新闻推荐</h2>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {related.map((item) => (
              <NewsCard key={item.id} news={item} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}